import React, { useContext, useEffect, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const GlobalSettingsContext = React.createContext(null);
const { Provider } = GlobalSettingsContext;

export const GlobalSettingsProvider = ({ ...props }) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({});

    const setGlobalSettingAsync = async (params) => {
        try {
            await fetchAuthorized(ApiRoutes.GlobalSettings.SetGlobalSetting(params),
            {                    
                method: HttpMethods.POST,
                body: JSON.stringify({}),
                collectErrorDetails: true
            });

          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            setGlobalSettingAsync,
        }}>
            {props.children}
        </Provider>
    );
}